import { render, staticRenderFns } from "./GeneralClaimSource.vue?vue&type=template&id=7451a3f8&"
import script from "./GeneralClaimSource.vue?vue&type=script&lang=js&"
export * from "./GeneralClaimSource.vue?vue&type=script&lang=js&"
import style0 from "./GeneralClaimSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports